/**
 * Tracks whether the player has completed their very first run, used to
 * decide whether to show the new-user tap hint + extended lead-in.
 *
 * Stored client-side in localStorage so the helping wheels are gone on the
 * second visit even if the user is anonymous (no server roundtrip).
 */

const FIRST_RUN_KEY = 'gd-first-run-completed';

export function isFirstTimePlayer(): boolean {
  if (typeof localStorage === 'undefined') return false;
  return localStorage.getItem(FIRST_RUN_KEY) !== '1';
}

export function markFirstRunComplete(): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(FIRST_RUN_KEY, '1');
}

/** Test helper - reset so tests can simulate a brand-new user. */
export function resetFirstRunForTest(): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(FIRST_RUN_KEY);
}
